(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ai-bear-showcase"] && !Shopify.designMode) return;
  try {
    

  function initABShowcase() {
    var sections = document.querySelectorAll('.ai-bear-showcase');
    sections.forEach(function (section) {

      // ===== 缩略图切换 =====
      var mainImage = section.querySelector('.ai-bear-showcase__main-image');
      var thumbs = section.querySelectorAll('[data-ab-thumb]');

      if (mainImage && thumbs.length > 0) {
        // 代数标记：快速连点时只有最后一次点击的切换生效
        var switchGen = 0;

        // 用与主图一致的 srcset/sizes 预载,确保浏览器选中同一变体 URL,切换时命中缓存
        function preloadThumb(thumb, onReady) {
          var src = thumb.getAttribute('data-ab-thumb-src');
          var srcset = thumb.getAttribute('data-ab-thumb-srcset');
          if (!src) return;
          var preload = new Image();
          if (srcset) preload.srcset = srcset;
          preload.sizes = mainImage.sizes || '100vw';
          preload.onload = onReady;
          preload.onerror = onReady;
          preload.src = src;
        }

        thumbs.forEach(function (thumb) {
          thumb.addEventListener('click', function () {
            var src = thumb.getAttribute('data-ab-thumb-src');
            var srcset = thumb.getAttribute('data-ab-thumb-srcset');
            if (!src) return;

            thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });

            // 重复点击当前图无需切换
            if (mainImage.src === new URL(src, window.location.href).href) return;

            var myGen = ++switchGen;

            function swap() {
              if (myGen !== switchGen) return;
              mainImage.style.opacity = '0';
              setTimeout(function () {
                if (myGen !== switchGen) return;
                mainImage.onload = function () {
                  mainImage.onload = null;
                  mainImage.onerror = null;
                  mainImage.style.opacity = '1';
                };
                mainImage.onerror = function () {
                  mainImage.onload = null;
                  mainImage.onerror = null;
                  mainImage.style.opacity = '1';
                };
                mainImage.src = src;
                if (srcset) mainImage.srcset = srcset;
                // 预载后命中缓存,complete 同步为 true 时直接淡入
                if (mainImage.complete) {
                  mainImage.onload = null;
                  mainImage.onerror = null;
                  mainImage.style.opacity = '1';
                }
              }, 150);
            }

            // 主图保持可见,等目标图预载完成(或 4s 超时兜底)再切换,全程无空白等待
            var fallback = setTimeout(swap, 4000);
            preloadThumb(thumb, function () {
              clearTimeout(fallback);
              swap();
            });
          });
        });

        // idle 预热全部大图:首次点击即命中缓存,秒切
        var idle = window.requestIdleCallback || function (fn) { setTimeout(fn, 1500); };
        idle(function () {
          thumbs.forEach(function (t) { preloadThumb(t, function () {}); });
        });
      }

      // ===== AJAX 加购 =====
      var form = section.querySelector('form[data-type="add-to-cart-form"]');
      if (!form) return;

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var btn = form.querySelector('.ai-bear-showcase__button');
        var originalText = btn ? btn.textContent : '';
        if (btn) {
          btn.disabled = true;
          btn.textContent = 'Adding...';
        }

        var formData = new FormData(form);

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (res) { return res.json(); })
          .then(function () {
            return fetch('/cart.js').then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: form.id,
                data: {
                  itemCount: cart.item_count,
                  source: 'product-form-component',
                  productId: form.dataset.productId || ''
                }
              }
            }));

            var cartDrawer = document.querySelector('cart-drawer-component, .cart-drawer, [data-cart-drawer]');
            if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            } else if (cartDrawer) {
              cartDrawer.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
            }

            if (btn) {
              btn.textContent = 'Added!';
              setTimeout(function () {
                btn.disabled = false;
                btn.textContent = originalText;
              }, 1500);
            }
          })
          .catch(function (err) {
            console.error('Add to cart failed:', err);
            if (btn) {
              btn.disabled = false;
              btn.textContent = originalText;
            }
          });
      });

    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initABShowcase);
  } else {
    initABShowcase();
  }

  // Shopify 编辑器内 section 重新渲染时重新绑定
  document.addEventListener('shopify:section:load', initABShowcase);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-scroll-reveal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(section) {
      if (section.dataset.heroRevealReady === 'true') return;
      section.dataset.heroRevealReady = 'true';

      var mqMobile = window.matchMedia('(max-width: 749px)');
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var isDesignMode = section.dataset.designMode === 'true';
      var enablePinOnMobile = section.dataset.mobileEnablePin === 'true';
      var curve = section.dataset.revealCurve || 'ease-out';
      var revealStart = (parseFloat(section.dataset.revealStart || '0') || 0) / 100;
      var revealEnd = (parseFloat(section.dataset.revealEnd || '100') || 100) / 100;
      if (revealEnd <= revealStart) revealEnd = Math.min(1, revealStart + 0.05);

      function shouldUsePin() {
        return !mqMobile.matches || enablePinOnMobile;
      }

      function applyCurve(raw) {
        var window = revealEnd - revealStart;
        var progress;
        if (window <= 0) {
          progress = raw >= revealEnd ? 1 : 0;
        } else {
          progress = (raw - revealStart) / window;
          progress = Math.max(0, Math.min(1, progress));
        }
        if (curve === 'linear') return progress;
        if (curve === 'ease-in') return progress * progress;
        return 1 - (1 - progress) * (1 - progress);
      }

      function setProgress(p) {
        section.style.setProperty('--reveal-progress', p.toFixed(3));
      }

      if (prefersReducedMotion) {
        setProgress(1);
        section.setAttribute('data-reveal-state', 'complete');
        return;
      }

      if (isDesignMode) {
        setProgress(1);
        section.setAttribute('data-reveal-state', 'complete');
        return;
      }

      if (!shouldUsePin()) {
        setProgress(0);
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              section.setAttribute('data-reveal-state', 'revealing');
              requestAnimationFrame(function () { setProgress(1); });
              setTimeout(function () {
                section.setAttribute('data-reveal-state', 'complete');
              }, 700);
              io.unobserve(section);
            }
          });
        }, { threshold: 0.35 });
        io.observe(section);
        section._cleanup = function () { io.disconnect(); };
        return;
      }

      var ticking = false;
      function update() {
        var rect = section.getBoundingClientRect();
        var total = section.offsetHeight - window.innerHeight;
        var raw = total > 0 ? Math.max(0, Math.min(1, -rect.top / total)) : 0;
        setProgress(applyCurve(raw));
        section.setAttribute('data-reveal-state',
          raw >= 0.999 ? 'complete' : raw > 0.001 ? 'revealing' : 'idle');
        ticking = false;
      }
      function onScroll() {
        if (!ticking) { requestAnimationFrame(update); ticking = true; }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      mqMobile.addEventListener('change', onScroll);
      update();

      section._cleanup = function () {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        mqMobile.removeEventListener('change', onScroll);
      };
    }

    function initAll() {
      document.querySelectorAll('[data-hero-reveal]').forEach(initSection);
    }

    initAll();

    document.addEventListener('shopify:section:load', function (e) {
      var target = e.target && e.target.querySelector('[data-hero-reveal]');
      if (target) initSection(target);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var target = e.target && e.target.querySelector('[data-hero-reveal]');
      if (target && target._cleanup) target._cleanup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
